module.exports = __webpack_public_path__ + "img/photo_240720778_3.ca90b99c.jpg";